module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IyE7fy/tc-custom/9781615817139.jpg?1692013314499",
      "alt": "This image is the cover for the book A Matter of Time: Vol. 1, A Matter of Time Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Matter of Time: Vol. 1, A Matter of Time Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Books One and Two"), _c('br'), _vm._v("Vol. 1")])])]), _c('p', [_vm._v("Jory Keyes leads a normal life as an architect’s assistant until he is witness to a brutal murder. Though initially saved by police Detective Sam Kage, Jory refuses protective custody—he has a life he loves that he won’t give up no matter who is after him. But Jory’s life is in real jeopardy, especially after he agrees to testify about what he saw.")]), _vm._v(" "), _c('p', [_vm._v("While dealing with attempts on his life, well-meaning friends who want to see him happy, an overly protective boss, and a slowly unfolding mystery that is much more sinister than he could ever imagine, the young gay man finds himself getting involved with Sam, the conflicted and closeted detective. And though Jory may survive the danger, he may not survive a broken heart.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Calmes\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0